module.exports = __webpack_public_path__ + "img/crossPreview.c53405e8.svg";